<template>
  <div class="row">
    <div class="col-md-6">
      <div class="form-group">
        <label>First Name</label>
        <input type="text" v-model="contactData.first_name" class="form-control"  v-on:keyup.enter="saveContactFn" ref="focusThis"/>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <label>Last Name</label>
        <input type="text" v-model="contactData.last_name" class="form-control"  v-on:keyup.enter="saveContactFn"/>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <label>Email</label>
        <input type="text" v-model="contactData.email_address" class="form-control"  v-on:keyup.enter="saveContactFn"/>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <label>{{deliverableContactCompanyLabel(get_deliverable_template_id())}}</label>
        <input type="text" v-model="contactData.company_name" class="form-control"  v-on:keyup.enter="saveContactFn"/>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <label>Phone</label>
        <input type="text" v-model="contactData.phone" class="form-control"  v-on:keyup.enter="saveContactFn"/>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <label>Mobile</label>
        <input type="text" v-model="contactData.cell_phone" class="form-control"  v-on:keyup.enter="saveContactFn"/>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <label>Fax</label>
        <input type="text" v-model="contactData.fax_number" class="form-control"  v-on:keyup.enter="saveContactFn"/>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <label>Website</label>
        <input type="text" v-model="contactData.website" class="form-control"  v-on:keyup.enter="saveContactFn"/>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <label>Country</label>
        <multiselect
          v-model="contactData.country_id"
          :options="allCountries"
          :multiple="false"
          @input="filterState"
        ></multiselect>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <label>Province</label>
        <multiselect v-model="contactData.province" :options="filteredStates" :multiple="false"></multiselect>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <label>City</label>
        <input type="text" v-model="contactData.city" class="form-control"  v-on:keyup.enter="saveContactFn"/>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <label>Postal Code</label>
        <input type="text" v-model="contactData.postal_code" class="form-control"  v-on:keyup.enter="saveContactFn"/>
      </div>
    </div>
    <div class="col-md-12">
      <div class="form-group">
        <label>Address</label>
        <textarea class="form-control" v-model="contactData.address"></textarea>
      </div>
    </div>
    <div class="col-md-12">
      <div class="form-group">
        <label>Notes</label>
        <textarea class="form-control" v-model="contactData.notes"></textarea>
      </div>
    </div>
    <div class="col-md-12">
      <div class="form-group">
        <button class="btn btn-primary" type="button" @click="saveContactFn" data-dismiss="modal">Save</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  data() {
    return {
      filteredStates: []
    };
  },
  props: ["namespace"],
  computed: {
  		...mapState({
  	  state (state) {
  	    return state[this.namespace]
  	  },
  	  allCountries (state, getters) {
  	    return getters[this.namespace + 'allCountries']
  	  },
  	  allStates (state, getters) {
  	    return getters[this.namespace + 'allStates']
  	  },
  	  deliverableDetail (state, getters) {
  	    return getters[this.namespace + 'deliverableDetail']
  	  },
  	  deliverableContactsLabel (state, getters) {
  	    return getters[this.namespace + 'deliverableContactsLabel']
  	  },
  	  deliverableContactCompanyLabel (state, getters) {
  	    return getters[this.namespace + 'deliverableContactCompanyLabel']
  	  },
      currentContactId: state => state.currentContactId,
      currentFieldKey: state => state.currentFieldKey
  	}),
    contactData() {
      return _.find(this.deliverableDetail.contacts, {
        id: this.currentContactId
      });
    }
  },
  methods: {
  	my_deliverable_template_id() {
  		return this.deliverableDetail.deliverable_template_id;
  	},
    focusMyElement() {
      this.$refs.focusThis.focus()
    },
    saveContactFn() {
      this.$store.dispatch(this.namespace + "updateContact", this.contactData);
      this.$bvModal.hide('editContactModal')
      //this.$store.commit("toggleEditContactModal");
    },
    filterState() {
      let allStatesData = this.allStates,
        usStates = allStatesData.slice(0, 50),
        canadaStates = allStatesData.slice(51);
      this.filteredStates =
        this.contactData.country_id == "Canada" ? canadaStates : usStates;
    }
  },
  created() {
    this.filterState();
  }
};
</script>

<style>
</style>